import React, { useState } from 'react'
import { Accordion, Card } from 'react-bootstrap'
import { IAccordionItem } from './model'
import './styles.scss'

interface AccordionProps {
  items: IAccordionItem[]
}

const AccordionList = ({ items }: AccordionProps): JSX.Element => {
  const [activeParentKey, setParentActiveKey] = useState<string>('-1') // State to hold the parent active key
  const [activeChildKey, setChildActiveKey] = useState<string>('-1') // State to hold the child active key

  const renderAccordion = (items: IAccordionItem[], nested = false) => {
    // Event handler to monitor Accordion state changes
    const handleAccordionSelect = (
      newActiveKey: string | null,
      parent: boolean
    ) => {
      if (newActiveKey === null || newActiveKey === undefined) {
        parent ? setParentActiveKey('-1') : setChildActiveKey('-1')
      } else {
        if (parent) {
          setParentActiveKey(newActiveKey as string)
          setChildActiveKey('-1')
        } else {
          setChildActiveKey(newActiveKey as string)
        }
      }
    }

    return (
      <Accordion
        className='accordionlist'
        activeKey={nested ? activeChildKey : activeParentKey}
        onSelect={(eventKey) => {
          return nested
            ? handleAccordionSelect(eventKey, false)
            : handleAccordionSelect(eventKey, true)
        }}
      >
        {items.map((item: IAccordionItem, index: number) => (
          <Card key={index} className='accordionlist-card'>
            <Accordion.Toggle
              as={Card.Header}
              eventKey={`${index}`}
              className={`accordionlist-header ${
                !nested ? 'pl-0' : 'nested-header'
              }`}
            >
              {item.title}
              {nested ? (
                activeChildKey === `${index}` ? (
                  <span className='accordion-up-icon mdi mdi-chevron-up'></span>
                ) : (
                  <span className='accordion-down-icon mdi mdi-chevron-down'></span>
                )
              ) : activeParentKey === `${index}` ? (
                <span className='accordion-up-icon mdi mdi-chevron-up'></span>
              ) : (
                <span className='accordion-down-icon mdi mdi-chevron-down'></span>
              )}
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={`${index}`}>
              {Array.isArray(item.content) && item.content.length ? (
                renderAccordion(item.content, true)
              ) : (
                <Card.Body
                  dangerouslySetInnerHTML={{ __html: item.content as string }}
                />
              )}
            </Accordion.Collapse>
          </Card>
        ))}
      </Accordion>
    )
  }
  return <React.Fragment>{renderAccordion(items)}</React.Fragment>
}

export default AccordionList
